var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'dp-columns',
    ("dp-columns--" + _vm.numberOfColumns + "-columns"),
    {
      'dp-columns--bordered': _vm.bordered,
    }
  ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }